/**
 * Initializes an Alpine.js data object to manage a page navigation submenu for specific product detail pages (PDPs).
 * Key features include:
 * 1. Smooth Scrolling: Enables smooth scrolling to sections within the PDP upon tab click.
 * 2. Dynamic Visibility: Shows or hides the navigation based on scroll position relative to a specified point.
 * 3. Swiper Integration: Uses Swiper for responsive, touch-friendly tab navigation.
 * 4. Scroll Throttling: Implements throttling to optimize scroll event handling and improve performance.
 */

const pageNavigationComponent = () => ({
  selectedIdx: 0,
  sectionElements: [],
  throttleTimer: false,
  showPoint: null,

  eventThrottle: (callback, time) => {
    if (this.throttleTimer) return;

    this.throttleTimer = true;

    setTimeout(() => {
      callback();
      this.throttleTimer = false;
    }, time);
  },

  get swiperTabsConfig() {
    return {
      slidesPerView: 'auto',
      freeMode: true,
    };
  },

  buildSwiper() {
    this.swiperTabsInstance = new Swiper(this.$el.querySelector('.swiper[swiper-page-nav]'), this.swiperTabsConfig);
  },

  initSections() {
    this.showPoint = document.getElementById('atc-cta');
    const navItems = this.$el.querySelectorAll('.page-nav-carousel-tabs__tab');
    this.sectionElements = Array.from(navItems).map((navItem) => {
      const id = navItem.getAttribute('data-section-id');
      return document.getElementById(id);
    });

    navItems.forEach((navItem, idx) => {
      navItem.addEventListener('click', () => {
        this.scrollToSection(idx);
      });
    });
  },

  scrollToSection(idx) {
    const section = this.sectionElements[idx];
    if (section) {
      window.scrollTo({
        top: section.offsetTop + 1,
        behavior: 'smooth',
      });
    }
  },

  handleScroll() {
    let currentIdx = this.sectionElements.findIndex((section, idx) => {
      const top = section?.getBoundingClientRect().top + window.scrollY;
      const bottom = top + section.offsetHeight;
      return window.scrollY >= top && window.scrollY < bottom;
    });

    if (currentIdx !== -1 && currentIdx !== this.selectedIdx) {
      this.selectedIdx = currentIdx;
      this.swiperTabsInstance.slideTo(currentIdx);
      this.updateActiveTab(currentIdx);
    }
    this.toggleNavigationVisibility();
  },

  updateActiveTab(currentIdx) {
    const tabs = this.$el.querySelectorAll('.page-nav-carousel-tabs__tab');
    tabs.forEach((tab, idx) => {
      if (idx === currentIdx) {
        tab.classList.add('page-nav-carousel-tabs__tab--active');
      } else {
        tab.classList.remove('page-nav-carousel-tabs__tab--active');
      }
    });
  },

  toggleNavigationVisibility() {
    if (this.sectionElements.length > 0) {
      const showSection = this.showPoint.getBoundingClientRect();
      const showSectionBottom = showSection.top + showSection.height + window.scrollY;
      //.top + window.scrollY;
      if (window.scrollY < showSectionBottom) {
        this.$el.style.visibility = 'hidden';
      } else {
        this.$el.style.visibility = 'visible';
      }
    }
  },

  init() {
    setTimeout(() => {
      this.buildSwiper();
      this.initSections();
      this.toggleNavigationVisibility();
      window.addEventListener('scroll', () => this.eventThrottle(() => this.handleScroll(), 100));
    }, 1000);
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('pageNavigationComponent', pageNavigationComponent);
});
